import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Share, Plus, X } from "lucide-react";
import { isIOS, isStandalone } from "@/lib/push";

let deferred = null;
if (typeof window !== "undefined") window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });

// "Install app" entry: native install prompt on Android/Chrome, Add-to-Home-Screen steps on iPhone.
export const InstallAppButton = ({ className = "", onDone }) => {
  const [hidden, setHidden] = useState(isStandalone());
  const [ios, setIos] = useState(false);
  useEffect(() => { const on = () => setHidden(true); window.addEventListener("appinstalled", on); return () => window.removeEventListener("appinstalled", on); }, []);
  if (hidden) return null;
  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      deferred = null;
      if (outcome === "accepted") { toast.success("Caption Motion added to your home screen"); setHidden(true); onDone?.(); }
    } else if (isIOS()) setIos(true);
    else toast.message("Open your browser menu and choose “Install app” or “Add to Home screen”.");
  };
  return (
    <>
      <button onClick={install} data-testid="install-app-btn" className={className}><Download size={18} className="text-[#00F0FF]" /> Install app</button>
      {ios && (
        <div className="fixed inset-0 z-[70] flex items-end bg-black/60" onClick={() => setIos(false)} data-testid="install-ios-sheet">
          <div className="w-full rounded-t-2xl border-t border-white/10 bg-[#111] p-5 pb-8 text-white" onClick={(e) => e.stopPropagation()}>
            <div className="mb-3 flex items-center justify-between"><span className="font-display text-lg font-black">Add to Home Screen</span><button onClick={() => setIos(false)}><X size={20} /></button></div>
            <ol className="space-y-3 text-sm text-white/80">
              <li className="flex items-center gap-2">1. Tap <Share size={16} className="text-[#0A84FF]" /> <b>Share</b> in Safari's toolbar</li>
              <li className="flex items-center gap-2">2. Choose <Plus size={16} /> <b>Add to Home Screen</b></li>
              <li>3. Tap <b>Add</b> — Caption Motion opens full-screen like an app.</li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
};
